/* tf-search-drawer-fix v2: open Search-Drawer even if theme custom elements failed to register */
(function () {
  function focusInput(drawer) {
    var input = drawer && drawer.querySelector('input[type="search"][name="q"]');
    if (input) setTimeout(function () { try { input.focus(); } catch (e) {} }, 60);
  }

  function fallbackShow(drawer, opener) {
    drawer.setAttribute("open", "");
    drawer.classList.add("tf-search-open");
    if (opener) opener.setAttribute("aria-expanded", "true");
    document.documentElement.classList.add("tf-search-drawer-open");
    document.body.setAttribute("scroll-y-off", "");
    focusInput(drawer);
  }

  function fallbackHide(drawer) {
    drawer.removeAttribute("open");
    drawer.classList.remove("tf-search-open");
    document.documentElement.classList.remove("tf-search-drawer-open");
    document.body.removeAttribute("scroll-y-off");
    var openers = document.querySelectorAll('modal-opener.search-drawer-opener-button[aria-expanded="true"]');
    openers.forEach(function (o) { o.setAttribute("aria-expanded", "false"); });
  }

  function ensureSearchDrawer() {
    if (customElements.get("search-drawer")) return;
    try {
      if (typeof Drawer !== "undefined") {
        customElements.define(
          "search-drawer",
          class extends Drawer {
            show(opener) {
              super.show(opener);
              var rec = this.querySelector("recommendation-by-history");
              if (rec && typeof rec.showContent === "function") rec.showContent();
            }
            hide() {
              super.hide();
              var rec = this.querySelector("recommendation-by-history");
              if (rec && typeof rec.abortFetch === "function") rec.abortFetch();
            }
          }
        );
        return;
      }
    } catch (e) {}

    try {
      customElements.define(
        "search-drawer",
        class extends HTMLElement {
          show(opener) {
            this.openedBy = opener || null;
            fallbackShow(this, opener);
          }
          hide() {
            fallbackHide(this);
            this.openedBy = null;
          }
        }
      );
    } catch (e) {}
  }

  function openDrawer(opener) {
    ensureSearchDrawer();
    var drawer = document.getElementById("Search-Drawer");
    if (!drawer) return false;

    // Upgrade path: if element was parsed before define, show may appear after define
    if (typeof drawer.show === "function") {
      try {
        drawer.show(opener || null);
        focusInput(drawer);
        return true;
      } catch (e) {}
    }

    fallbackShow(drawer, opener);
    return true;
  }

  function bindOpeners() {
    document.querySelectorAll("modal-opener.search-drawer-opener-button, [aria-controls='Search-Drawer']").forEach(function (opener) {
      if (opener.dataset.tfSearchBound === "1") return;
      opener.dataset.tfSearchBound = "1";

      var link = opener.querySelector("a.fallback-link");
      if (link) {
        link.style.pointerEvents = "none";
        link.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openDrawer(opener);
        }, true);
      }

      opener.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openDrawer(opener);
        },
        true
      );

      opener.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          openDrawer(opener);
        }
      });
    });

    // Close on overlay click / Escape
    var drawer = document.getElementById("Search-Drawer");
    if (drawer && drawer.dataset.tfSearchCloseBound !== "1") {
      drawer.dataset.tfSearchCloseBound = "1";
      drawer.addEventListener("click", function (e) {
        if (e.target && e.target.classList && e.target.classList.contains("modal-overlay")) {
          if (typeof drawer.hide === "function") drawer.hide();
          else fallbackHide(drawer);
        }
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && drawer.hasAttribute("open")) {
          if (typeof drawer.hide === "function") drawer.hide();
          else fallbackHide(drawer);
        }
      });
      var closeBtn = drawer.querySelector(".drawer-close-button");
      if (closeBtn) {
        closeBtn.addEventListener("click", function (e) {
          e.preventDefault();
          if (typeof drawer.hide === "function") drawer.hide();
          else fallbackHide(drawer);
        });
      }
    }
  }

  function boot() {
    ensureSearchDrawer();
    bindOpeners();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  window.addEventListener("load", boot);
  [0, 200, 800, 2000].forEach(function (ms) { setTimeout(boot, ms); });
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("modal-opener").then(boot).catch(function () {});
    customElements.whenDefined("drawer-component").then(boot).catch(function () {});
  }
})();
